import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import * as React from 'react';

const MAX_RECENT_SEARCHES = 5;

/**
 * Atom to store the recent searches done by the user.
 */
const recentSearchesAtom = atomWithStorage<string[]>('recentSearches', [], undefined, {
    getOnInit: true,
});

/**
 * List the recent searches.
 */
export function useRecentSearches(): string[] {
    return useAtomValue(recentSearchesAtom);
}

/**
 * Add a new search to the recent searches.
 */
export function useRegisterRecentSearch(query: string) {
    const setRecentSearches = useSetAtom(recentSearchesAtom);

    React.useEffect(() => {
        if (!query) {
            return;
        }

        const timeout = setTimeout(() => {
            setRecentSearches((recentSearches) => {
                if (recentSearches.includes(query)) {
                    return recentSearches;
                }

                return [query, ...recentSearches.slice(0, MAX_RECENT_SEARCHES - 1)];
            });
        }, 3000);

        return () => clearTimeout(timeout);
    }, [query]);
}
